import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { infoTagConfig, tokens } from '../../constants';
import { TRANSPARENT } from '../../constants/colors';
import { fitContentWidth } from '../../utils';
export var infoTagColorStyles = props => {
  var _a, _b, _c, _d, _e, _f;
  var config = props.config,
    subType = props.subType,
    disabled = props.disabled;
  var _subType = disabled ? 'disabled' : subType;
  var color = (_b = (_a = config === null || config === void 0 ? void 0 : config.subType) === null || _a === void 0 ? void 0 : _a[_subType]) === null || _b === void 0 ? void 0 : _b.color;
  var backgroundColor = (_d = (_c = config === null || config === void 0 ? void 0 : config.subType) === null || _c === void 0 ? void 0 : _c[_subType]) === null || _d === void 0 ? void 0 : _d.bgColor;
  var borderColor = (_f = (_e = config === null || config === void 0 ? void 0 : config.subType) === null || _e === void 0 ? void 0 : _e[_subType]) === null || _f === void 0 ? void 0 : _f.borderColor;
  return {
    color,
    backgroundColor,
    borderColor: borderColor || TRANSPARENT
  };
};
var getInfoTagBorderRadius = type => {
  var borderRadiusStyle = {
    borderRadius: tokens.borderRadius.BORDER_RADIUS_4
  };
  if (type === 'on-card') {
    borderRadiusStyle = {
      borderTopLeftRadius: tokens.borderRadius.BORDER_RADIUS_8,
      borderTopRightRadius: tokens.borderRadius.BORDER_RADIUS_8,
      borderBottomRightRadius: 0,
      borderBottomLeftRadius: 0
    };
  }
  return borderRadiusStyle;
};
var getInfoTagIconPositionStyle = iconPosition => {
  var iconPositionSpacing = {};
  if (iconPosition === 'left') {
    iconPositionSpacing = {
      marginRight: tokens.spacing.SPACING_4
    };
  } else {
    iconPositionSpacing = {
      marginLeft: tokens.spacing.SPACING_4
    };
  }
  return iconPositionSpacing;
};
var setFlexDirection = position => {
  return position === 'left' ? {
    flexDirection: 'row'
  } : {
    flexDirection: 'row-reverse'
  };
};
export var getInfoTagStyles = props => {
  var _a, _b;
  var config = props.config,
    iconName = props.iconName,
    iconPosition = props.iconPosition,
    size = props.size,
    transformToUppercase = props.transformToUppercase,
    type = props.type;
  var spacing = tokens.spacing;
  var mainContainerConfigStyles = (_b = (_a = config === null || config === void 0 ? void 0 : config.size) === null || _a === void 0 ? void 0 : _a[size]) === null || _b === void 0 ? void 0 : _b[type];
  return StyleSheet.create({
    container: Object.assign(Object.assign(Object.assign(Object.assign({
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderWidth: 1,
      height: mainContainerConfigStyles === null || mainContainerConfigStyles === void 0 ? void 0 : mainContainerConfigStyles.height,
      textTransform: transformToUppercase && 'uppercase',
      paddingHorizontal: spacing[mainContainerConfigStyles === null || mainContainerConfigStyles === void 0 ? void 0 : mainContainerConfigStyles.paddingHorizontal]
    }, fitContentWidth()), iconName && setFlexDirection(iconPosition)), getInfoTagBorderRadius(type)), infoTagColorStyles(props)),
    iconContainer: Object.assign({}, getInfoTagIconPositionStyle(iconPosition))
  });
};
export var getInfoTagTextStyle = (size, type) => {
  var _a;
  var textTypes = {
    inline: {
      sm: 'body-single-line-xs-bold',
      md: 'body-single-line-sm-bold',
      lg: 'body-single-line-md-bold'
    },
    'on-card': {
      sm: 'body-single-line-xs-bold',
      md: 'body-single-line-sm-bold',
      lg: 'body-single-line-sm-bold'
    }
  };
  return (_a = textTypes[type]) === null || _a === void 0 ? void 0 : _a[size];
};
export var getInfoTagProps = (props, context) => {
  var _a, _b, _c, _d;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(infoTagConfig === null || infoTagConfig === void 0 ? void 0 : infoTagConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.infoTag) === null || _a === void 0 ? void 0 : _a[theme]);
  var type = (props === null || props === void 0 ? void 0 : props.type) || (configProps === null || configProps === void 0 ? void 0 : configProps.type);
  var size = (props === null || props === void 0 ? void 0 : props.size) || (configProps === null || configProps === void 0 ? void 0 : configProps.size);
  var subType = (props === null || props === void 0 ? void 0 : props.subType) || (configProps === null || configProps === void 0 ? void 0 : configProps.subType);
  var iconSizeConfig = (_c = (_b = configProps === null || configProps === void 0 ? void 0 : configProps.config) === null || _b === void 0 ? void 0 : _b.size[size]) === null || _c === void 0 ? void 0 : _c[type];
  var subTypeConfig = (_d = configProps === null || configProps === void 0 ? void 0 : configProps.config) === null || _d === void 0 ? void 0 : _d.subType[subType];
  var iconPropsConfig = {
    width: iconSizeConfig === null || iconSizeConfig === void 0 ? void 0 : iconSizeConfig.iconSize,
    height: iconSizeConfig === null || iconSizeConfig === void 0 ? void 0 : iconSizeConfig.iconSize,
    color: subTypeConfig === null || subTypeConfig === void 0 ? void 0 : subTypeConfig.color
  };
  var iconProps = (props === null || props === void 0 ? void 0 : props.iconProps) || iconPropsConfig;
  return Object.assign(Object.assign(Object.assign({
    theme
  }, configProps), props), {
    iconProps
  });
};